import React from 'react';
import { pcConstants } from '../constants';

export const useHideLastPcDiv = () => {
	React.useEffect(() => {
		document.getElementById(pcConstants.bottomSignInId)?.setAttribute('style', 'display:none;');
	}, []);
};
